/**
 * @module video/videoinsert
 */
import { Plugin } from '@ckeditor/ckeditor5-core';
import VideoUpload from './videoupload';
import VideoInsertUI from './videoinsert/videoinsertui';
export default class VideoInsert extends Plugin {
    /**
     * @inheritDoc
     */
    static get pluginName() {
        return 'VideoInsert';
    }
    /**
     * @inheritDoc
     */
    static get requires() {
        return [VideoUpload, VideoInsertUI];
    }
}
//# sourceMappingURL=videoinsert.js.map